import { NetworkError } from "hooks/usePublicAPI";

import {
  accountGrantFailureOf,
  parseAccountGrant,
  type AccountGrantResult,
} from "./account";
import { requestAccountGrant } from "./api";

/** Asks for a grant to create the account for a quote with, using the
 * quote's own device session. Asking again replaces a grant that ended.
 * `report` hears of a failure that was not a plain refusal. */
export async function startAccountGrant(
  quoteId: string,
  report: (error: unknown) => void,
): Promise<AccountGrantResult> {
  try {
    const answer = parseAccountGrant(
      await requestAccountGrant(quoteId),
      quoteId,
    );
    if (answer === null) return { kind: "not_available" };
    if (answer.kind === "existing_account") return answer;
    return { kind: "granted", state: answer.state };
  } catch (error) {
    const failure = accountGrantFailureOf(
      error instanceof NetworkError ? error.statusCode : undefined,
    );
    if (failure.kind === "failed") report(error);
    return failure;
  }
}
